import React from 'react';
import ReactDOM from 'react-dom';
import RankBrain2SidebarNavbar from 'RankBrain2SidebarNavbar';
import RankBrain2SidebarToggleButtonWithHover from 'RankBrain2SidebarToggleButton';

import {
  Desktop,
  Tablet,
  Mobile,
} from 'Responsive';


export default class RankBrain2SidebarLanding extends React.Component {
  static init(id, props) {
    ReactDOM.render(
      <RankBrain2SidebarLanding {...props} />,
      document.getElementById(id),
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      isSideBarOpen: false,
    };

    this.toggleSideBar = this.toggleSideBar.bind(this);
  }

  toggleSideBar() {
    this.setState({
      isSideBarOpen: !this.state.isSideBarOpen,
    });
  }

  render() {
    let sidebar = (
      <RankBrain2SidebarToggleButtonWithHover
        toggleSideBar={this.toggleSideBar}
        className="pull-right btn rank-brain-2-sidebar-toggle-button-landing"
        hoverImgSrc="/images/rank-brain-2/icon-sections-white-2x.png"
        imgSrc="/images/rank-brain-2/icon-sections-white-2x.png"
      />
    );
    const toggleProps = {
      toggleSideBar: this.toggleSideBar,
      includeText: false,
      hoverImgSrc: '/images/rank-brain-2/close-hover.png',
      imgSrc: 'images/rank-brain-2/close-default.png',
    };

    let sidebarClass = 'rank-brain-2-sidebar-landing';
    if (this.state.isSideBarOpen) {
      sidebar = (
        <RankBrain2SidebarNavbar
          {...this.props}
          toggleProps={toggleProps}
          includeToggleSideBar
        />
      );

      sidebarClass = 'rank-brain-2-sidebar-landing sidebar-expanded';
    }
    return (
      <React.Fragment>
        <Desktop>
          <div className={`${sidebarClass} rank-brain-2-sidebar-landing-desktop`}>
            <RankBrain2SidebarNavbar toggleProps={toggleProps} {...this.props} />
          </div>
        </Desktop>
        <Tablet>
          <div className={`${sidebarClass} rank-brain-2-sidebar-landing-tablet`}>
            {sidebar}
          </div>
        </Tablet>
        <Mobile>
          <div className={`${sidebarClass} rank-brain-2-sidebar-landing-mobile`}>
            {sidebar}
          </div>
        </Mobile>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src-react/RankBrain2SidebarLanding/index.jsx